module.exports = __webpack_public_path__ + "packs/media/images/pic03-8b8f037c560a820ae25eb75734a6123b.jpg";